export default __webpack_public_path__ + "static/media/lockIcon.0cabf895.svg";